/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BanInputs */

const th_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระงับบัญชี`)
};

const en_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ban`)
};

const ja_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用停止にする`)
};

const zh_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`封禁`)
};

const es_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear`)
};

const pt_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear`)
};

const id_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blokir`)
};

const fr_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquer`)
};

const tl_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-ban`)
};

const vi_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấm`)
};

const ko_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차단`)
};

const de_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sperren`)
};

const ru_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заблокировать`)
};

const tr_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engelle`)
};

const it_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocca`)
};

const pl_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zablokuj`)
};

const uk_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заблокувати`)
};

const hi_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिबंधित करें`)
};

const ar_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حظر`)
};

const ms_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekat`)
};

const bn_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিষিদ্ধ করুন`)
};

const zh_tw2_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停權`)
};

const zh_hk2_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停權`)
};

const ur_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پابندی لگائیں`)
};

const fa_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسدود کردن`)
};

const sw_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuia`)
};

const nl_ban = /** @type {(inputs: BanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blokkeren`)
};

/**
* | output |
* | --- |
* | "Ban" |
*
* @param {BanInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const ban = /** @type {((inputs?: BanInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BanInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_ban(inputs)
	if (locale === "ja") return ja_ban(inputs)
	if (locale === "zh") return zh_ban(inputs)
	if (locale === "es") return es_ban(inputs)
	if (locale === "pt") return pt_ban(inputs)
	if (locale === "id") return id_ban(inputs)
	if (locale === "fr") return fr_ban(inputs)
	if (locale === "tl") return tl_ban(inputs)
	if (locale === "vi") return vi_ban(inputs)
	if (locale === "ko") return ko_ban(inputs)
	if (locale === "de") return de_ban(inputs)
	if (locale === "ru") return ru_ban(inputs)
	if (locale === "tr") return tr_ban(inputs)
	if (locale === "it") return it_ban(inputs)
	if (locale === "pl") return pl_ban(inputs)
	if (locale === "uk") return uk_ban(inputs)
	if (locale === "hi") return hi_ban(inputs)
	if (locale === "ar") return ar_ban(inputs)
	if (locale === "ms") return ms_ban(inputs)
	if (locale === "bn") return bn_ban(inputs)
	if (locale === "zh-TW") return zh_tw2_ban(inputs)
	if (locale === "zh-HK") return zh_hk2_ban(inputs)
	if (locale === "ur") return ur_ban(inputs)
	if (locale === "fa") return fa_ban(inputs)
	if (locale === "sw") return sw_ban(inputs)
	if (locale === "nl") return nl_ban(inputs)
	return en_ban(inputs)
});